import React, { useState } from 'react';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { SpecialKeys } from '../utils';
import { AppStore } from '../../../../AppStore';

type KeyProps = {
  value: string;
  handleInput: (value: string) => void;
};

const Key = ({ value, handleInput }: KeyProps) => {
  const hapticFeedbackEnabled = AppStore.useState(s => s.userData?.settings.hapticFeedbackEnabled) ?? true;
  const [isTouchActive, setIsTouchActive] = useState(false);

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (!isTouchActive) {
      try {
        navigator.vibrate(20);
      } catch (error) {
        // do nothing, just don't vibrate
      }
      handleInput(value);
      event.currentTarget.blur();
    }
    setIsTouchActive(false); // Reset the flag after a potential click
  };

  const handleTouchStart: React.TouchEventHandler<HTMLButtonElement> = () => {
    setIsTouchActive(true);
    try {
      if (hapticFeedbackEnabled) {
        navigator.vibrate(20);
      }
    } catch (error) {
      // do nothing, just don't vibrate
    }
    handleInput(value);
  };

  const handleTouchEnd: React.TouchEventHandler<HTMLButtonElement> = () => {
    // We don't need to do anything specific on touch end in this case
    // because handleInput is already called on touch start.
    // Setting isTouchActive to false in handleClick handles the click case.
  };

  const isWideKey = value === SpecialKeys.Enter || value === SpecialKeys.Delete;

  const getSymbol = (value: string) => {
    if (value === SpecialKeys.Delete) {
      return <BackspaceOutlinedIcon />;
    } else {
      return value;
    }
  };

  return (
    <button
      className={`${isWideKey ? 'wideKey' : ''} keyboardKey`}
      onClick={handleClick}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {getSymbol(value)}
    </button>
  );
};

export default Key;